import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=78f7486a&scoped=true"
import script from "./detection.vue?vue&type=script&lang=ts"
export * from "./detection.vue?vue&type=script&lang=ts"
import style0 from "./detection.vue?vue&type=style&index=0&id=78f7486a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7486a",
  null
  
)

export default component.exports